import React, { useState, useTransition } from "react";
import { useSelector } from "react-redux";
import { Nav, NavItem, NavLink, Row, TabContent, TabPane } from "reactstrap";
import classnames from "classnames";
import { useFormikContext } from "formik";
import { useAppSelector } from "../../store";
import { InputKey } from "./type";
import GetInput from "./GetInput";
import { useTranslation } from "react-i18next";

const MultiLanguageInput = ({ inputKeys }: { inputKeys: InputKey[] }) => {
  const { t } = useTranslation();
  const languages = useAppSelector((state) => state.language.languages);
  const [multiple, setMultiple] = useState(false);
  const { setFieldValue, handleBlur, values, errors, touched } =
    useFormikContext<any>();
  const [activeTab, setactiveTab] = useState(languages[0].EnumId);
  const toggle = (tab: any) => {
    if (activeTab !== tab) {
      setactiveTab(tab);
    }
  };
  // console.log(errors, "Errors");
  // console.log(values, "Values");
  return (
    <React.Fragment>
      {!multiple ? (
        inputKeys.map((key, i) => (
          <GetInput
            inputprop={key}
            key={i}
            error={errors[key.field]}
            touch={touched[key.field]}
            overrideOnChange={(e) => {
              if (key.isEditor) {
                setFieldValue(`${key.field}`, e);
                for (let i = 0; i < values.Translates.length; i++) {
                  setFieldValue(`Translates[${i}].${key.field}`, e);
                }
              } else {
                setFieldValue(`${key.field}`, e.target.value);
                for (let i = 0; i < values.Translates.length; i++) {
                  setFieldValue(
                    `Translates[${i}].${key.field}`,
                    e.target.value
                  );
                }
              }
            }}
          />
        ))
      ) : (
        <>
          <Nav className="multiLanguageNavbar nav-tabs-custom mx-3">
            {languages.map((lang) => (
              <NavItem key={lang.EnumId}>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: activeTab === lang.EnumId,
                  })}
                  onClick={() => {
                    toggle(lang.EnumId);
                  }}
                >
                  {lang.Code.split("-")[1]}
                </NavLink>
              </NavItem>
            ))}
          </Nav>
          <TabContent activeTab={activeTab} className="px-3 pt-3 text-muted">
            {languages.map((lang) => {
              var currentIndex = values.Translates.findIndex((x: any) => {
                return x.LanguageId === lang.EnumId;
              });
              return (
                <TabPane tabId={lang.EnumId} key={lang.EnumId}>
                  <Row>
                    {inputKeys.map((key, i) => {
                      const disabledvalue = key.onDisabilityChange
                        ? key.onDisabilityChange(values)
                        : false;
                      return key.onHiding && key.onHiding(values) ? (
                        <></>
                      ) : (
                        <GetInput
                          error={
                            errors.Translates &&
                            //@ts-ignore
                            errors.Translates[currentIndex] &&
                            //@ts-ignore
                            errors.Translates[currentIndex][key.field]
                          }
                          touch={
                            touched.Translates &&
                            //@ts-ignore
                            touched.Translates[currentIndex] &&
                            //@ts-ignore
                            touched.Translates[currentIndex][key.field]
                          }
                          value={
                            values.Translates &&
                            //@ts-ignore
                            values.Translates[currentIndex] &&
                            //@ts-ignore
                            values.Translates[currentIndex][key.field]
                          }
                          inputprop={{
                            isEditor: key.isEditor,
                            field: `Translates[${currentIndex}].${key.field}`,
                            label: key.label,
                          }}
                          key={i}
                          disabledvalue={disabledvalue}
                          overrideOnChange={(e) => {
                            if (key.isEditor) {
                              setFieldValue(`${key.field}`, e);
                              setFieldValue(
                                `Translates[${currentIndex}].${key.field}`,
                                e
                              );
                            } else {
                              setFieldValue(`${key.field}`, e.target.value);
                              setFieldValue(
                                `Translates[${currentIndex}].${key.field}`,
                                e.target.value
                              );
                            }
                          }}
                        />
                      );
                    })}
                  </Row>
                </TabPane>
              );
            })}
          </TabContent>
        </>
      )}

      <div className="d-flex justify-content-end">
        <button
          className="btn-light btn"
          style={{
            backgroundColor: "transparent",
            marginInlineEnd: 10,
            fontSize: 11,
            marginBlockEnd: 10,
          }}
          onClick={() => setMultiple(!multiple)}
        >
          {!multiple
            ? t("MultilanguageComponent.Multilanguage")
            : t("MultilanguageComponent.SingleLanguage")}
        </button>
      </div>
    </React.Fragment>
  );
};

export default MultiLanguageInput;
